import { timefitBackend } from '../../../Shared/Services/TimefitBackend';
import { keys } from '../../../Shared/Services/Query/Keys.ts';
import { useRecord } from '../../../Shared/Hooks/useRecord/useRecord.ts';

export function useUser(key: string) {
  const queryFn = () => timefitBackend.getUser(key);

  return useRecord(keys.users.one(key), queryFn);
}
